import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import firebase from './firebase_vue_plugin';
import store from './store';

loadFonts();

createApp(App)
  .use(store)
  .use(vuetify)
  .use(firebase)
  .mount('#app');
